import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'

type PurchaseMultiCartItemsRequest = Omit<paths['/api/carts/multi-carts/{multiCartId}/purchase']['post']['parameters']['body']['payload'], 'brand'>
type PurchaseMultiCartItemsResponse = paths['/api/carts/multi-carts/{multiCartId}/purchase']['post']['responses']['204']['content']['application/json']

export function purchaseMultiCartItems(
  multiCartId: string,
  checkoutCartId: string,
  orderId: string,
): Promise<PurchaseMultiCartItemsResponse> {
  return request.post<PurchaseMultiCartItemsResponse, PurchaseMultiCartItemsRequest>(
    `/api/carts/multi-carts/${multiCartId}/purchase`,
    { checkoutCartId, orderId },
    { credentials: 'include' },
  )
}
